var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie"},[_c('span',{staticClass:"type"},[_vm._v("用户使用工具类型统计")]),_c('div',{staticStyle:{"height":"350px","width":"100%"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }